import { FilterOperators } from '@agilox/common';

const TECHNICAL_DATA_PATH = '/fleet/technical-data';
const UPDATES_TAB = 'updates';
const SERIAL_COLUMN = 'serial';
const SERIAL_SEPARATOR = ',';

export const MAX_DEEP_LINK_SERIALS = 100;

export function technicalDataDeepLink(serials: string[] = []): string {
	const params = new URLSearchParams({ tab: UPDATES_TAB });

	if (serials.length && serials.length <= MAX_DEEP_LINK_SERIALS) {
		params.set('column', SERIAL_COLUMN);
		params.set('operator', FilterOperators.EQUAL);
		params.set('version', serials.join(SERIAL_SEPARATOR));
	}

	return `${TECHNICAL_DATA_PATH}?${params}`;
}
